export const ADAPTER_WORKFLOW_OPEN_STATE_STORAGE_KEY = "adapter-workflow-open-state";

export interface AdapterWorkflowOpenState {
  releaseId: string;
  definitionId: string;
}

const getStorage = (): Storage | undefined => {
  if (typeof window === "undefined") return undefined;
  return window.localStorage;
};

export const getAdapterWorkflowOpenState = (): AdapterWorkflowOpenState | undefined => {
  try {
    const rawValue = getStorage()?.getItem(ADAPTER_WORKFLOW_OPEN_STATE_STORAGE_KEY);
    if (!rawValue) return undefined;
    const value = JSON.parse(rawValue) as Partial<AdapterWorkflowOpenState>;
    if (typeof value.releaseId !== "string" || typeof value.definitionId !== "string") return undefined;
    if (!value.releaseId.trim() || !value.definitionId.trim()) return undefined;
    return { releaseId: value.releaseId, definitionId: value.definitionId };
  } catch {
    return undefined;
  }
};

export const setAdapterWorkflowOpenState = (state: AdapterWorkflowOpenState): void => {
  try {
    getStorage()?.setItem(ADAPTER_WORKFLOW_OPEN_STATE_STORAGE_KEY, JSON.stringify(state));
  } catch {
    return;
  }
};

export const clearAdapterWorkflowOpenState = (): void => {
  try {
    getStorage()?.removeItem(ADAPTER_WORKFLOW_OPEN_STATE_STORAGE_KEY);
  } catch {
    return;
  }
};
